export default "__VITE_ASSET__f5$ygAiy__"